import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Tooltip from 'components/widgets/overlays/tooltip';
import classNames from 'classnames';
import { connect } from 'react-redux';


function UserInitials({ user: passedUser, userId, users, className, ...passedProps }) {
  if (_.isEmpty(passedUser) && !userId) return null;

  const user = passedUser || _.find(users, { id: userId }) || {};
  const title = `${user.firstName} ${user.lastName}`;
  const first = _.head(user.firstName);
  const last = _.head(user.lastName);
  const initials = user.poPrefix || _.toUpper(first) + _.toUpper(last);
  const isThreeCharacters = initials.length === 3;

  return (
    <Tooltip
      {..._.omit(passedProps, ['dispatch'])}
      className={classNames('user-initials', { 'badge-three-char': isThreeCharacters }, className)}
      title={title}
    >
      {initials}
    </Tooltip>
  );
}

UserInitials.propTypes = {
  user: PropTypes.object,
  userId: PropTypes.number,
  className: PropTypes.string,
  users: PropTypes.array.isRequired
};

export default connect((state) => ({
  users: state.pageData.selectUsers
}))(UserInitials);
